module.exports = __webpack_public_path__ + "static/media/magnet.c1b9f57e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/magnet.svg
// module id = 528
// module chunks = 0